/**
 * Catalog taxonomy a bounded context may assign to a widget so it lands under the
 * right tab in the widget catalog (KPIs / Gráficas / Tablas / Sistema).
 *
 * This is the framework-owned set of categories a widget can BE. The catalog's
 * "Todos" tab is a UI-only filter sentinel (see `CATALOG_ALL` in the dashboard BC),
 * deliberately NOT part of this taxonomy — a widget is never categorized as "all".
 */
export const WIDGET_CATEGORY = {
  KPIS: 'kpis',
  CHARTS: 'charts',
  TABLES: 'tables',
  SYSTEM: 'system',
} as const;

export type WidgetCategory = (typeof WIDGET_CATEGORY)[keyof typeof WIDGET_CATEGORY];
